const rtf = new Intl.RelativeTimeFormat('en', { style: 'short', numeric: 'auto' })

export function relativeTime(date: Date): string {
  const diff = (date.getTime() - Date.now()) / 1000
  const abs = Math.abs(diff)
  if (abs < 60) return rtf.format(Math.round(diff), 'second')
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute')
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour')
  if (abs < 30 * 86400) return rtf.format(Math.round(diff / 86400), 'day')
  if (abs < 365 * 86400) return rtf.format(Math.round(diff / (30 * 86400)), 'month')
  return rtf.format(Math.round(diff / (365 * 86400)), 'year')
}

export function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms}ms`
  const s = Math.round(ms / 1000)
  if (s < 60) return `${s}s`
  const m = Math.floor(s / 60)
  const rs = s % 60
  if (m < 60) return `${m}m ${rs}s`
  const h = Math.floor(m / 60)
  const rm = m % 60
  return `${h}h ${rm}m`
}

export function formatLocal(date: Date): string {
  return date.toLocaleString(undefined, {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

export function formatWeekday(date: Date): string {
  return date.toLocaleString(undefined, { weekday: 'short' })
}
